import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../bloc/general_bloc";
import RouteBloc from "../../../bloc/route_bloc";
import AppHeader from "../../component/app_header/app_header";
import AppHeaderTitleSimple from "../../component/app_header_title/app_header_title_simple";
import Base_screen from "../base/base_screen/base_screen";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import HomeBloc from "../../../bloc/home_bloc";
import Config from "../../../Config";

import "./quotation_details_screen.css";
import AppModal from "../../component/app_modal/app_modal";
import AppStandardDetailsCard from "../../component/app_quotation_card/app_standard_details_card";
import AppGeneratedDocumentsDetailsCard from "../../component/app_quotation_card/app_generated_documents_card2";
import AppCardStatus from "../../component/app_card_status/app_card_status";
import QuotationBloc from "../../../bloc/quotation_bloc";
import AppBottomBar from "../../component/app_bottom_bar/app_bottom_bar";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";
import AppLoadingDialog from "../../dialog/app_loading_dialog";

class QuotationDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            formData: null,
            isClientApproved: false,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            isSuccessModalOpen: false,
            isOpen: false,
            loading: false
        };
    }


    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        this.getUserData();
        this.getQuotationData()
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    async getUserData(){
        let userData = await UserAccessBloc.getUserData();
        let userSettings = await UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
    }

    async getQuotationData() {
        this.setState({ loading: true });
        let userData = await UserAccessBloc.getUserData();
        let quotationDetails = await QuotationBloc.getQuotationDetail(this.getQuotationID(), userData.username); //'SHA002'

        if (quotationDetails) {
            if (quotationDetails.status == 'GENERATED') {
                this.checkProposalStatus()
            }
            this.setState({
                loading: false,
                refNo: quotationDetails.refNo,
                status: quotationDetails.status,
                formDetails: quotationDetails,
            })
        } else {
            this.setState({
                loading: false,
                isOpen: true,
                title: 'Error',
                description: quotationDetails.message
            })
        }

    }

    async checkProposalStatus() {
        try {
            let proposalResult = await ProposalBloc.getProposalByQuotationId(this.getQuotationID());

            this.setState({
                proposalDetails: proposalResult,
                isClientApproved: (proposalResult?.trxStatus == 'PENDING_SUBMISSION' || proposalResult?.trxStatus == 'SUBMITTED') ? true : false
            });
        } catch (e) {
            console.log(e)
        }
    }

    initiateData() { }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    getQuotationID() {
        return this.props.match.params.itemId;
    }

    getStatus() {
        return this.props.status;
    }

    stateModule() {
        return "quotation";
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    async handleGoUpdateProposal() {
        this.setState({ loading: true })

        let editable = await ProposalBloc.editGeneratedProposal(this.state.proposalDetails.proposalId);
        if (editable.success) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_provide_details}/${this.state.proposalDetails.proposalId}`
        } else {
            this.setState({
                loading: false,
                isOpen: true,
                title: 'Notification',
                description: 'This proposal cannot be edit or update.'
            })
        }
    }

    viewProposal() {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_details}/${this.state.proposalDetails.proposalId}`
    }

    handleMessageModalClose = () => {
        this.setState({ isOpen: false });
    }

    handleMessageModalOpen = () => {
        this.setState({ isOpen: true });
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleSuccessModalOpen = () => {
        this.setState({ isSuccessModalOpen: true })
    }
    handleSuccessModalClose = () => {
        this.setState({ isSuccessModalOpen: false })
    }

    handleGoBackToDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`
    }

    handleGoBackToQuotationDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    handleGoCreateProposal = () => {

    }

    handleGoUpdateQuotation = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_personal_details}/${this.getQuotationID()}`
    }

    handleStopWithoutSaving = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    handleNextStep() {
        window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_review_submit}/${this.getQuotationID()}`
    }

    async handleDeleteQuotation() {
        let userData = UserAccessBloc.getUserData();
        this.setState({ loading: true });
        let response = await QuotationBloc.deleteQuotationById(this.getQuotationID());
        if (response.success) {
            this.setState({
                isDeleteModalOpen: false,
                loading: false
            })
            this.handleGoBackToQuotationDashboard();

        } else {
            this.setState({
                isDeleteModalOpen: false,
                loading: false,
                isOpen: true,
                title: 'Error',
                errorMessage: 'Quotation delete failed.'
            })
        }
    }

    handleFormSubmit() {
        this.handleSuccessModalOpen();
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <AppHeader
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        />
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150,
                                fontFamily: 'Lato'
                            }}
                        >
                            {this.state.loading && this.loadingContent()}
                            <div className="row m-0 w-100">
                                <AppHeaderTitleSimple
                                    title={'Ref No. ' + this.stateFormDetails()?.refNo}
                                    handleBack={() => this.handleGoBackToQuotationDashboard()}
                                />
                            </div>
                            <div className="px-5">
                                <AppCardStatus
                                    status={this.stateFormDetails()?.status}
                                    module={'quotation'}
                                />
                            </div>

                            <div className="w-100 px-3 pb-4">
                                {this.stateFormDetails()?.personalDetails && (
                                    <AppStandardDetailsCard
                                        data={this.stateFormDetails().personalDetails}
                                        fields={
                                            Config.quotation.dataDetailMapping.personalDetails ||
                                            []
                                        }
                                        header={this.stateFormDetails().personalDetails.caption}
                                    />
                                )}

                                {this.stateFormDetails()?.financialDetails && (
                                    <AppStandardDetailsCard
                                        data={this.stateFormDetails()?.financialDetails}
                                        fields={
                                            Config.quotation.dataDetailMapping.financialDetails ||
                                            []
                                        }
                                        header={this.stateFormDetails()?.financialDetails.caption}
                                    />
                                )}
                                {this.stateFormDetails()?.takafulDetails && (
                                    <AppStandardDetailsCard
                                        data={this.stateFormDetails().takafulDetails}
                                        // data={}
                                        fields={
                                            Config.quotation.dataDetailMapping.takafulDetails ||
                                            []
                                        }
                                        header={this.stateFormDetails().takafulDetails.caption}
                                    />
                                )}
                                {this.stateFormDetails()?.generatedDocuments && (
                                    <AppGeneratedDocumentsDetailsCard
                                        module={this.stateModule()}
                                        data={this.stateFormDetails().generatedDocuments}
                                    />
                                )}

                            </div>

                        </div>
                        {
                            (this.stateFormDetails()?.status === 'PENDING') &&
                            <AppBottomBar
                                enable={true}
                                lableDiscard={'Delete'}
                                lableSaveAndClose={'Update Quotation'}
                                lableNext={'Proceed to Proposal'}
                                onDiscard={(e) => this.handleDiscardModalOpen()}
                                onSaveAndClose={(e) => this.handleGoUpdateQuotation()}
                                alignContent={"right"}
                                buttonWidth={"auto"}
                                onNext={(e) => {
                                    this.createNewProposal();
                                }}
                            />
                        }
                        {   // true here should be the indicator whether client is approve
                            (this.stateFormDetails()?.status === 'GENERATED' && this.state.isClientApproved == false) &&
                            <AppBottomBar
                                enable={true}
                                lableSaveAndClose={'Update Quotation'}
                                lableNext={'Update Proposal'}
                                onDiscard={(e) => this.handleDiscardModalOpen()}
                                onSaveAndClose={(e) => this.handleGoUpdateQuotation()}
                                alignContent={"right"}
                                buttonWidth={"auto"}
                                onNext={(e) => {
                                    this.handleGoUpdateProposal();
                                }}
                            />
                        }
                        {
                            this.state.isClientApproved &&
                            <AppBottomBar
                                enable={true}
                                lableNext={'View Proposal'}
                                // onSaveAndClose={(e)=> this.viewProposal()}
                                alignContent={"right"}
                                buttonWidth={"auto"}
                                onNext={(e) => {
                                    this.viewProposal();
                                }}
                            />
                        }
                        <AppModal
                            open={this.state.isDiscardModalOpen}
                            handleModalClose={this.handleDiscardModalClose}
                            width={'50%'}
                            title={'Do you want to delete this quotation ?'}
                            subtitle={'If you delete this quotation, you wil loose any progress you\'ve made.'}
                            negativeButtonText={'Cancel'}
                            positiveButtonText={'Yes, Delete'}
                            handleNegativePress={() => this.handleDiscardModalClose()}
                            handlePositivePress={() => this.handleDeleteQuotation()}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.isOpen}
                            handleModalClose={() => this.handleMessageModalClose()}
                            width={'50%'}
                            title={this.state.title}
                            subtitle={this.state.description}
                            positiveButtonText={'Close'}
                            handlePositivePress={() => this.handleMessageModalClose()}
                            closable={false}
                        />
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(QuotationDetails));
